'use strict';

import {EventEmitter} from 'events';

export interface ITsBusyService {
    busy(): void;
    free(): void;
}

export class TsBusyService extends EventEmitter implements ITsBusyService {
    busy() {
        this.emit('busy');
    }

    free() {
        this.emit('free');
    }
}
